import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';

export type DeleteChecklistCategoriesRequest = { ids: string[] };

async function deleteChecklistCategories(req: DeleteChecklistCategoriesRequest, checklistId: string): Promise<void> {
    const { data } = await api.delete(`/checklists/${checklistId}/categories`, { data: req });
    return data;
}

export function useDeleteChecklistCategories(
    checklistId: string
): UseMutationResult<void, unknown, DeleteChecklistCategoriesRequest, unknown> {
    return useMutation((req) => deleteChecklistCategories(req, checklistId), {
        onSettled: () => {
            queryClient.invalidateQueries(['checklists', checklistId]);
        },
    });
}
